package org.gymly.auth

import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.pointerInput
import kotlinx.coroutines.delay

/**
 * Cierra sesión tras [SessionIdlePolicy.idleTimeoutMs] sin actividad del usuario.
 * En web/escritorio escucha eventos del sistema; en móvil también gestos táctiles.
 */
@Composable
fun SessionIdleGuard(
    active: Boolean,
    onIdleTimeout: () -> Unit,
) {
    if (!active) return

    LaunchedEffect(Unit) {
        SessionActivity.syncFromPersistence()
        if (SessionActivity.isIdleExpired()) {
            onIdleTimeout()
        }
    }

    DisposableEffect(Unit) {
        val remove = installIdleActivityListener { SessionActivity.touch() }
        onDispose { remove() }
    }

    LaunchedEffect(Unit) {
        while (true) {
            delay(SessionIdlePolicy.checkIntervalMs)
            if (SessionActivity.isIdleExpired()) {
                onIdleTimeout()
                return@LaunchedEffect
            }
        }
    }
}

/** Registra toques y desplazamientos como actividad (móvil y respaldo multiplataforma). */
fun Modifier.trackSessionActivity(active: Boolean): Modifier {
    if (!active) return this
    return pointerInput(Unit) {
        awaitEachGesture {
            awaitFirstDown(requireUnconsumed = false, pass = PointerEventPass.Initial)
            SessionActivity.touch()
        }
    }
}
